/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Inventory } from '../../models/inventory';
import { InventoryWithRelations } from '../../models/inventory-with-relations';

export interface CreateNewInventory$Params {
      body?: Inventory
}

export function createNewInventory(http: HttpClient, rootUrl: string, params?: CreateNewInventory$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryWithRelations>> {
  const rb = new RequestBuilder(rootUrl, createNewInventory.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryWithRelations>;
    })
  );
}

createNewInventory.PATH = '/admin/inventories';
